<script lang="ts" setup>
const props = defineProps<{ data: Charity }>()
const classEvent = COLLECTION_CLASS_MAP.events

useSeoMeta({
  title: props.data?.name,
  twitterDescription: props.data?.brief ?? '',
  twitterTitle: props.data?.name,
  ogTitle: props.data?.name,
  ogDescription: props.data?.brief ?? '',
  description: props.data?.brief ?? '',
})

useHead({
  link: [
    {
      rel: 'canonical',
      href: getPublicRoute('charities', props.data, true),
    },
  ],
})
</script>

<template>
  <div class="relative">
    <div class="absolute top-0 left-0 right-0">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 320"
      ><path
        class="fill-pink"
        fill-opacity="1"
        d="M0,256L48,250.7C96,245,192,235,288,208C384,181,480,139,576,128C672,117,768,139,864,149.3C960,160,1056,160,1152,160C1248,160,1344,160,1392,160L1440,160L1440,0L1392,0C1344,0,1248,0,1152,0C1056,0,960,0,864,0C768,0,672,0,576,0C480,0,384,0,288,0C192,0,96,0,48,0L0,0Z"
      /></svg>
    </div>
    <div class="grid lg:grid-cols-3 gap-12 pt-32 px-6 max-w-7xl mx-auto relative lg:pt-64 items-center">
      <div class="w-full">
        <ImageFull
          :id="data.id"
          loading="lazy"
          :collection-id="data.collectionId"
          :src="data.logo"
          class="w-full h-auto max-w-3xl rounded-lg"
        />
      </div>
      <div class="w-full lg:col-span-2 ">
        <HeadingText
          tag="h1"
          :class="classEvent.heading"
        >
          {{ data.name }}
        </HeadingText>
      </div>
    </div>
    <main class="max-w-7xl p-6 mx-auto bg-slate-50 rounded-lg md:p-8 lg:p-12 gap-6 flex flex-col mt-12">
      <section class="w-full">
        <template v-if="data.website">
          <UTooltip text="Visit Website">
            <UButton
              icon="ri:link"
              aria-label="Visit Website"
              target="_blank"
              :to="data.website"
            >
              Website
            </UButton>
          </UTooltip>
        </template>
        <template v-if="data.phone">
          <UTooltip :text="`Call ${data.name}`">
            <UButton
              icon="ri:phone-line"
              :aria-label="`Call ${data.name}`"
              target="_blank"
              :to="`tel:${data.phone}`"
            >
              Call
            </UButton>
          </UTooltip>
        </template>
      </section>
      <section
        v-if="data?.description"
        class="htmldescription  mx-auto lg:text-lg"
      >
        <div
          data-allow-mismatch
          v-html="data.description"
        />
      </section>

      <p class="font-display text-xl lg:text-2xl uppercase font-black mt-6">
        Share
      </p>
      <SocialShare
        facebook
        twitter
        linked-in
      />
    </main>
  </div>
</template>
